export default "/images/IMDB.svg?c7b25e799ae80295d0359664d70eee96";